// Simple number formatting utility.
// Uses Indian grouping (en-IN) to match merchant formatting like 1,00,000.
export function formatNumber(value, decimals = 2) {
  if (value === null || value === undefined || value === "") return value;
  const num = Number(value);
  if (Number.isNaN(num)) return value;

  // Determine fraction digits: if decimals=0 or integer, show no decimals
  const isInteger = Number.isInteger(num);
  const minimumFractionDigits = isInteger ? 0 : Math.max(0, decimals);
  const maximumFractionDigits = Math.max(0, decimals);

  try {
    return new Intl.NumberFormat("en-IN", {
      minimumFractionDigits,
      maximumFractionDigits,
    }).format(num);
  } catch (err) {
    // Fallback
    return num.toFixed(decimals);
  }
}

export default formatNumber;
